import { FieldDefinition, FieldBuilder, MENU_CATEGORY_KEY, MENU_NAME_SUFFIX, MENU_SUBCATEGORY_KEY, MenuCategories, MenuSubcategories } from '@zendra/shared';
import { PatrimonyActivityParameterService } from '../proxy/controlling/controllers/patrimony-activity-parameter.service';
import { LocationTypeService } from '@planning/proxy/planning/controllers/location-type.service'

FieldBuilder.setNamespace('Controlling');

export const LOCATIONTYPEPERACTIVITY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('patrimonyActivityParameterId', 'Entity.PatrimonyActivityParameter', PatrimonyActivityParameterService)
    .required()
    .display('name')
    .keyField('id') 
    .hideInChildForms()
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('locationTypeId', 'Entity.LocationTypePerActivity.LocationType', LocationTypeService)
    .required()
    .display('name')
    .keyField('id')
    .build(),
];

export const LOCATIONTYPEPERACTIVITY_CONFIG = {
  entityName: 'LocationTypePerActivity',
  localizationKey: 'Controlling::Entity.LocationTypePerActivity',
  fields: LOCATIONTYPEPERACTIVITY_FIELDS,
  permission: 'ControllingActivities.LocationTypePerActivities',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
